(function() {
  function initLuxuryTestimonialsEngine() {
    const mainNode = document.querySelector('.luxury-testimonials');
    if (!mainNode) return;

    // ==========================================
    // 1. PARALLAX SCROLL FOR TEXT
    // ==========================================
    const parallaxTargets = [
      { element: mainNode.querySelector('.lt-main-heading'), factor: -0.15 },
      { element: mainNode.querySelector('.lt-subheading-text'), factor: -0.08 },
      { element: mainNode.querySelector('.lt-secondary-heading'), factor: -0.12 },
      { element: mainNode.querySelectorAll('.lt-section-title')[0], factor: -0.10 },
      { element: mainNode.querySelectorAll('.lt-section-title')[1], factor: -0.10 },
      { element: mainNode.querySelector('.lt-insta-title'), factor: -0.08 },
      { element: mainNode.querySelector('.lt-insta-sub-copy'), factor: -0.05 }
    ];

    function handleFontParallax() {
      if (window.innerWidth < 750) return; 
      const scrolled = window.scrollY;
      parallaxTargets.forEach(target => {
        if (!target.element) return;
        const rect = target.element.getBoundingClientRect();
        const elementOffsetTop = rect.top + scrolled;
        const viewportHeight = window.innerHeight;
        if (scrolled + viewportHeight > elementOffsetTop && scrolled < elementOffsetTop + rect.height) {
          const relativeScroll = scrolled + (viewportHeight / 2) - elementOffsetTop;
          const translateY = relativeScroll * target.factor;
          target.element.style.transform = `translate3d(0, ${translateY}px, 0)`;
        }
      });
    }
    window.addEventListener('scroll', () => { window.requestAnimationFrame(handleFontParallax); }, { passive: true });

    // ==========================================
    // 2. INFINITE AUTOMATED REVIEWS SCROLLER
    // ==========================================
    const sliderViewport = mainNode.querySelector('.js-lt-slider');
    if (sliderViewport && sliderViewport.children.length > 0) {
      const elementsToDupe = Array.from(sliderViewport.children);
      elementsToDupe.forEach(card => {
        const clonedCard = card.cloneNode(true);
        sliderViewport.appendChild(clonedCard);
      });
      const rawSpeedSetting = parseInt(mainNode.getAttribute('data-auto-speed') || 4);
      const actualDuration = (11 - rawSpeedSetting) * 6; 
      sliderViewport.style.setProperty('--scroll-duration', `${actualDuration}s`);
    }

    // ==========================================
    // 3. FIXED: INSTANT AUTOPLAY AND CLICK-TO-VOICE LIGHTBOX
    // ==========================================
    const reelCards = mainNode.querySelectorAll('.js-video-trigger');
    const lightbox = document.querySelector('.id-lt-video-lightbox');
    const iframeTarget = lightbox?.querySelector('.lt-lightbox-video-target-frame');
    const lightboxClose = lightbox?.querySelector('.js-lightbox-close');

    const clearLightbox = () => {
      if (lightbox) {
        lightbox.classList.remove('is-open');
        if (iframeTarget) iframeTarget.innerHTML = '';
        document.body.style.overflow = '';
      }
    };

    reelCards.forEach(card => {
      const nativeUrl = card.getAttribute('data-native-url');
      if (!nativeUrl) return;

      const thumbBox = card.querySelector('.lt-reel-thumb-box');
      
      // FIXED: Inject active autoplay loops right into the grid track columns immediately on document initialization
      const inlineVideo = document.createElement('video');
      inlineVideo.src = nativeUrl;
      inlineVideo.className = 'lt-inline-preview';
      inlineVideo.muted = true;
      inlineVideo.autoplay = true;
      inlineVideo.loop = true;
      inlineVideo.playsInline = true;
      inlineVideo.style.opacity = '1'; /* Secure solid structural rendering asset states */
      inlineVideo.setAttribute('preload', 'auto');
      
      thumbBox.appendChild(inlineVideo);

      // Expand to portrait Reel popup lightbox view with full voice audio activated upon card click
      card.addEventListener('click', (e) => {
        e.preventDefault();
        if (!iframeTarget || !lightbox) return;

        iframeTarget.innerHTML = '';
        const lightboxVideo = document.createElement('video');
        lightboxVideo.src = nativeUrl;
        lightboxVideo.controls = true;
        lightboxVideo.autoplay = true;
        lightboxVideo.playsInline = true;
        lightboxVideo.muted = false; // FIXED: Forces system volume and voice outputs active instantly
        
        iframeTarget.appendChild(lightboxVideo);
        lightbox.classList.add('is-open');
        document.body.style.overflow = 'hidden';
      });
    });

    if (lightbox && lightboxClose) {
      lightboxClose.addEventListener('click', (e) => { e.stopPropagation(); clearLightbox(); });
      lightbox.addEventListener('click', (e) => { if (e.target === lightbox) clearLightbox(); });
    }

    // ==========================================
    // 4. CTAS INPUT MODALS & GLOBAL SHORTCUTS
    // ==========================================
    const openFormBtn = mainNode.querySelector('.js-form-modal-trigger');
    const formModal = document.querySelector('.id-lt-form-modal');
    const closeFormBtn = formModal?.querySelector('.js-form-close');
    const hideForm = () => { if (formModal) { formModal.classList.remove('is-open'); document.body.style.overflow = ''; } };

    if (openFormBtn && formModal && closeFormBtn) {
      openFormBtn.addEventListener('click', (e) => { e.preventDefault(); formModal.classList.add('is-open'); document.body.style.overflow = 'hidden'; });
      closeFormBtn.addEventListener('click', (e) => { e.stopPropagation(); hideForm(); });
      formModal.addEventListener('click', (e) => { if (e.target === formModal) hideForm(); });
    }

    window.addEventListener('keydown', (e) => { if (e.key === 'Escape') { clearLightbox(); hideForm(); } });
  }

  document.addEventListener('DOMContentLoaded', initLuxuryTestimonialsEngine);
  if (Shopify.designMode) { document.addEventListener('shopify:section:load', initLuxuryTestimonialsEngine); }
})();